import { Text } from 'preact-i18n';
import flexibleCalendarImg from '../../../assets/images/flexible-calendar.webp';
import flexibleCalendarFlatImg from '../../../assets/images/flexible-calendar-flat.webp';

import ReturnOpenSwitch from './ReturnOpenSwitch';

const OpenTicketSection = ({
  flatVariant,
  returnIsOpen,
  handleToggleOpenReturn,
}) => (
  <div className="udp-open-ticket">
    <div className="udp-open-ticket__content">
      <div className="udp-open-ticket__text">
        <div className="udp-open-ticket__header">
          <span className="udp-open-ticket__title">
            <Text id="label.open_ticket_title" />
          </span>
          <img
            src={flatVariant ? flexibleCalendarFlatImg : flexibleCalendarImg}
            className="udp-open-ticket__img"
            alt=""
            aria-hidden="true"
          />
        </div>
        <div className="udp-open-ticket__divider" />
        <div className="udp-open-ticket__description">
          <span className="udp-open-ticket__subtitle">
            <Text id="label.open_ticket_subtitle" />
          </span>
          <span className="udp-open-ticket__subtitle">
            <Text id="label.open_ticket_redeem" />
          </span>
        </div>
      </div>
    </div>
    <ReturnOpenSwitch
      returnIsOpen={returnIsOpen}
      handleToggleOpenReturn={handleToggleOpenReturn}
      flatVariant={flatVariant}
    />
  </div>
);

export default OpenTicketSection;
